// Central brand configuration. Update copy here — components should never
// hardcode brand strings directly.

export const brand = {
  name: "The Planet",
  shortName: "The Planet",
  descriptor: "Cloud, Servers & Digital Infrastructure",
  tagline: "Infrastructure Built to Perform. Designed to Scale.",
  supportingMessage:
    "The Planet provides reliable VPS, dedicated servers, cloud infrastructure, business email, and security solutions designed to support modern digital businesses.",
  trustLine:
    "Flexible infrastructure for developers, startups, agencies and growing businesses.",
} as const;

export const announcement = {
  enabled: true,
  message:
    "Power your business with scalable servers, cloud infrastructure and professional email.",
  ctaLabel: "Explore Solutions",
  ctaHref: "/#solutions",
} as const;
